module.exports = __webpack_public_path__ + "static/media/dz.2a9282c9.svg";